import {
  gql 
} from "@apollo/client";

export const ADD_STUDENT_DISCOUNT = gql`
    mutation addDiscountInfo(
        $email: String!
        $firstname: String!
        $lastname: String!
        $image: String!
        $type_id: Int!
    ) {
        addDiscountInfo(
            input: {
                email: $email
                firstname: $firstname
                lastname: $lastname
                image: $image
                type_id: $type_id
            }
        ) {
            code
            message
            content
        }
    }
`;

export default {
  addStudentDiscountMutation: ADD_STUDENT_DISCOUNT
};
